// extracted by mini-css-extract-plugin
export default {"wrapper":"globalLayout_wrapper__nL2sD","main":"globalLayout_main__SeFrW"};